import { FC } from "react";
import { Form, Grid } from "antd";
import dayjs from "dayjs";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { CalendarIcon } from "src/assets/Icons";
import { useTranslation } from "react-i18next";
import CheckOutComponentWeb from "./layouts/CheckOutComponent.web";
import CheckOutComponentMob from "./layouts/CheckOutComponent.mob";

const CheckOutSelectComponent = withConditionalComponent(CheckOutComponentWeb, CheckOutComponentMob);

const CheckOutComponent: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const form = Form.useFormInstance();
  const checkin = Form.useWatch("checkin", form);

  const name = "checkout";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: CalendarIcon,
    label: t("Hotels.common.checkOut"),
    hasError,
    disabledDate: (d: dayjs.Dayjs) => {
      if (d.isBefore(dayjs(), "day")) return true;
      if (checkin) {
        if (!d.isAfter(checkin, "day")) return true;
        if (d.isAfter(checkin.add(1, "month"), "day")) return true;
      }
      return false;
    },
    className: "flex-5 h-15! border-none! focus-within:ring-0! focus:outline-none! text-font-default! w-full font-semibold",
  };

  return <CheckOutSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default CheckOutComponent;
